type TKlConfig = {
    filenameBase: string; // part of filename when downloading drawing
    disableAutoFit?: boolean;
};

export const KL_CONFIG: TKlConfig = {
    filenameBase: 'Klecks',
};
